"use client";

import React from "react";
import { FaShieldAlt } from "react-icons/fa";

export default function TermConditon() {
    return (
        <main className="min-h-screen bg-white py-12 px-6">
            <div className="max-w-6xl mx-auto  rounded-2xl  p-10">
                {/* Header Section */}
                <div className="text-center mb-10">
                    <FaShieldAlt className="text-blue-600 text-6xl mx-auto mb-4" />
                    <h1 className="text-4xl font-bold text-gray-900">
                        Sureship – Privacy policy
                    </h1>
                    <p className="text-gray-500 mt-2">
                        Last Updated: October 2025 | Please read carefully before use.
                    </p>
                </div>

                {/* Intro Section */}
                <section className="space-y-4 text-gray-700 leading-relaxed mb-10">
                    <p>
                        Your privacy is important to us. This privacy statement provides
                        information about the personal information that Sureship collects,
                        and the ways in which Sureship uses that personal information. We
                        collect, the personal basic Information about you including your
                        name, email address, Contact details etc.
                    </p>

                    <ul className="list-disc ml-6 space-y-2 text-gray-700">
                        <li>
                            Information about transactions carried out over this website.
                        </li>
                        <li>
                            Sureship may use your personal information to for following
                            purposes.
                        </li>
                        <li>Enable your access to and use of the website services</li>
                        <li>Publish information about you on the website</li>
                        <li>Supply to you services that you purchase</li>
                        <li>Send to you statements and invoices</li>
                        <li>Collect payments from you, and</li>
                    </ul>

                    <p>
                        Where we disclose your personal information to our agents or
                        sub-contractors for these purposes, the agent or sub-contractor in
                        question will be obligated to use that personal information in
                        accordance with the terms of this privacy statement.
                    </p>
                </section>

                {/* User Responsibility */}
                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">
                        Penalty for disputed shipments/cases
                    </h2>
                    <p className=" text-gray-700">
                        Sureship, in its sole discretion, shall have the right to levy
                        penalty on the Merchant in relation to shipments /cases which have
                        been disputed by the courier company, Merchant’s customer or by any
                        third party (including any governmental authority/department).The
                        said penalty amount shall be decided by Sureship in its sole
                        discretion and may vary from case to case.
                    </p>
                </section>



                {/* Shipment Policy */}
                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">
                        Securing your data
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                        Securing your data is our responsibility. We will take reasonable
                        technical and organizational precautions to prevent the loss, misuse
                        or alteration of your personal information. Sureship will store all
                        the personal information you provide on its secure servers.
                        Information relating to electronic transactions entered into via
                        this website will be protected by encryption technology.
                    </p>
                </section>



                {/* Footer */}
                <footer className="border-t border-gray-200 pt-6 text-center text-gray-600 text-sm">
                    <p>
                        &copy; {new Date().getFullYear()} Sureship Logistics Pvt. Ltd. | All
                        Rights Reserved.
                    </p>
                    <p className="mt-1">
                        For questions, please contact{" "}
                        <a
                            href="mailto:support@sureship.in"
                            className="text-blue-600 underline hover:text-blue-800"
                        >
                            support@sureship.in
                        </a>
                    </p>
                </footer>
            </div>
        </main>
    );
}
